import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Image from 'next/future/image';
import { schoolBanner } from 'src/utils/definitions';
import { imageLoader } from 'src/utils/imageOptimizer';
import { Form } from './';
import { ShareButton } from '../../shared/Share';
import { FollowSchool } from '../FollowSchool';
import useSignUpModal from '../../../hooks/useSignUpModal';
import styles from './Header.module.sass';

export const Header = () => {
  const { t } = useTranslation();
  const { openSignup, SignUpComponent } = useSignUpModal();
  const school = useSelector((state) => state.get('school'))?.toJS() || {};
  const isLogged = useSelector((state) => state.get('header')).get('isLogged') || false;
  const { hero, school_category, color_dark } = school;


  return (
    <div className={styles.Header} style={{ backgroundImage: `url(${schoolBanner[school_category]})` }}>
      <div className={`${styles.HeaderGrid} u-wrapper`}>
        <div className={styles.HeaderHead}>
          <div className={styles.HeaderHeadTop}>
            <figure>
              <Image loader={imageLoader} src={hero.badge} alt={hero.title} width={68} height={68} />
            </figure>
            <div>
              <span style={{ color: color_dark }}>{t('escuela.header.label')}</span>
              <h1>{hero.title}</h1>
            </div>
          </div>
          <p className={styles.HeaderHeadSubtitle}>{hero.subtitle}</p>
          <div className={styles.HeaderButtons}>
            {isLogged ? (
              <FollowSchool />
            ) : (
              <button onClick={openSignup} className={styles.BuyButton}>
                Crea una cuenta y empieza ya
              </button>
            )}
            <ShareButton
              isLogged={isLogged}
              messages={{
                isLogged: t('escuela.share.buttonToShareShort'),
                notLogged: t('escuela.share.buttonToShare'),
                sharedCopy: t('escuela.share.copy'),
              }}
              socialNetworkTitle={hero.title}
            />
          </div>
        </div>
        {!isLogged && (
          <div className={styles.HeaderForm}>
            <Form />
          </div>
        )}
      </div>
      <SignUpComponent />
    </div>
  );
};
